import { render, staticRenderFns } from "./PriceRuleEdit.vue?vue&type=template&id=4376de57&scoped=true"
import script from "./PriceRuleEdit.vue?vue&type=script&lang=ts"
export * from "./PriceRuleEdit.vue?vue&type=script&lang=ts"
import style0 from "./PriceRuleEdit.vue?vue&type=style&index=0&id=4376de57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4376de57",
  null
  
)

export default component.exports